import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadDataSource';
export const dataSourceDetailActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
const dataSourceDetailPrefix = 'dataSourceDetail';
export const dataSourceDetailConstants = {
    SetDataSourceContext: `${dataSourceDetailPrefix}/SetDataSourceContext`,
};
const setDataSourceContext = (state, actionResult) => {
    return {
        ...state,
        items: actionResult.payload,
    };
};
export function SetDataSourceContext(items) {
    return {
        type: dataSourceDetailConstants.SetDataSourceContext,
        payload: items.items,
    };
}
// Action Creators
export const dataSourceDetailLoadAction = (workspaceId, dataSourceName) => {
    return {
        type: dataSourceDetailActionTypes.LOAD,
        payload: { workspaceId: workspaceId, dataSourceName: dataSourceName },
    };
};
export const dataSourceDetailLoadingAction = (payload) => {
    return {
        type: dataSourceDetailActionTypes.LOADING,
        payload: payload,
    };
};
export const dataSourceDetailLoadedAction = (payload, result) => {
    return {
        type: dataSourceDetailActionTypes.LOADED,
        payload: {
            items: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case dataSourceDetailConstants.SetDataSourceContext:
            return setDataSourceContext(state, action);
        case dataSourceDetailActionTypes.LOADING:
            return {
                ...state,
                items: {
                    ...state.items,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case dataSourceDetailActionTypes.LOADED:
            const loadedAction = action;
            return {
                ...state,
                items: loadedAction.payload.items,
            };
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=DataSourceDetail.ducks.js.map
